<template>
    <div class="user-profile-summary-wrap mb-40px">
        <h1 class="mb-20px bg-gray fs-17 p-3 radius-4 d-flex align-center justify-content-between">Summary</h1>
        <div class="row">
            <div class="col-md-4">
                <div class="user-profile-summary user-reputation d-flex flex-column justify-content-between h-full">
                    <h3>Reputation</h3>
                    <div class="user-profile-summary-content user-reputation-content">
                        <h2>331</h2>
                        <p>top <b>67%</b> this year</p>
                    </div>
                    <div class="user-reputation-footer d-flex justify-content-between">
                        <div class="user-reputation-top-tag">
                            <span>Top Tag</span>
                            <ul class="tag-list p-0">
                                <li>
                                    <a class="tag" href="#">html</a>
                                </li>
                            </ul>
                        </div>
                        <el-progress
                            class="user-reputation-progress-bar w-full"
                            :text-inside="true"
                            :stroke-width="20"
                            :percentage="50"
                            status="success"
                            >
                            <span>Next privilege</span>
                        </el-progress>
                    </div>

                </div>
            </div>

            <div class="col-md-4">
                <div class="user-profile-summary user-badges-wrap d-flex flex-column justify-content-between h-full">
                    <div>
                        <h3>Badges</h3>
                        <div class="user-badges-lists d-flex w-full align-center justify-content-between">
                            <div class="user-badge q-badge badge badge-gold">
                                4
                            </div>
                            <div class="user-badge q-badge badge badge-silver">
                                13
                            </div>
                            <div class="user-badge q-badge badge badge-bronze">
                                14
                            </div>
                        </div>
                    </div>
                    <div class="user-badges-footer d-flex align-center">
                        <div class="user-badges-footer-left">
                            <h6>Newest</h6>
                            <router-link to="/" class="d-flex user-badge q-badge badge badge-silver">
                                Constituent
                            </router-link>
                        </div>
                        <div class="user-badges-footer-right w-full">
                            <h6 class="d-flex align-center justify-content-between">Next badge <span class="count">1/30</span></h6>
                            <el-progress
                                :text-inside="true"
                                :stroke-width="20"
                                :percentage="10"
                                status="info"
                                >
                                <span class="d-flex align-center gap-1"><span class="type-badge badge-silver"></span> Enthusiast</span>
                            </el-progress>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-4">
                <div class="user-profile-summary user-impact d-flex flex-wrap justify-content-between h-full">
                    <h3 class="w-full">Impact</h3>
                    <div class="user-impact-lists d-grid w-full position-relative">
                        <div class="user-impact-item">
                            <h3>~19k</h3>
                            <span>people reached</span>
                        </div>
                        <div class="user-impact-item">
                            <h3>43</h3>
                            <span>posts edited</span>
                        </div>
                        <div class="user-impact-item">
                            <h3>6</h3>
                            <span>helpful flags</span>
                        </div>
                        <div class="user-impact-item">
                            <h3>12</h3>
                            <span>votes cast</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UserProfileSummary'
}
</script>